import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1f511ff9")

_pushScopeId("data-v-1f511ff9")
const _hoisted_1 = { class: "top-line mb-4 admin-main-top-line" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-2" }
const _hoisted_4 = { class: "img-wrap" }
const _hoisted_5 = { class: "col-9" }
const _hoisted_6 = { class: "menu list" }
const _hoisted_7 = { class: "list__item" }
const _hoisted_8 = { class: "list__item" }
const _hoisted_9 = { class: "list__item" }
const _hoisted_10 = { class: "list__item" }
const _hoisted_11 = { class: "list__item" }
const _hoisted_12 = { class: "list__item" }
const _hoisted_13 = /*#__PURE__*/_createVNode("li", { class: "list__item" }, [
  /*#__PURE__*/_createVNode("div", { class: "divider" })
], -1)
const _hoisted_14 = { class: "list__item" }
const _hoisted_15 = { class: "col-1" }
const _hoisted_16 = { class: "user" }
const _hoisted_17 = {
  key: 0,
  class: "logout-profile"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  class: "menu__img"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM12.4653 12.936C12.0227 11.6207 10.7987 10.6667 9.33333 10.6667H6.66667C5.20133 10.6667 3.97867 11.6213 3.536 12.9367C2.18733 11.716 1.33333 9.958 1.33333 8C1.33333 4.324 4.324 1.33333 8 1.33333C11.676 1.33333 14.6667 4.324 14.6667 8C14.6667 9.95733 13.8133 11.7153 12.4653 12.936Z" }),
  /*#__PURE__*/_createVNode("path", { d: "M8.00016 3.3335C6.5275 3.3335 5.3335 4.5275 5.3335 6.00016V6.66683C5.3335 8.1395 6.5275 9.3335 8.00016 9.3335C9.47283 9.3335 10.6668 8.1395 10.6668 6.66683V6.00016C10.6668 4.5275 9.47283 3.3335 8.00016 3.3335Z" })
], -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "admin-with-cogwheels" }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/_createVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18"
}, [
  /*#__PURE__*/_createVNode("path", {
    id: "input_icon",
    d: "M14.2222 0H1.77778C0.791111 0 0 0.791111 0 1.77778V5.33333H1.77778V1.77778H14.2222V14.2222H1.77778V10.6667H0V14.2222C0 14.6937 0.187301 15.1459 0.520699 15.4793C0.854097 15.8127 1.30628 16 1.77778 16H14.2222C14.6937 16 15.1459 15.8127 15.4793 15.4793C15.8127 15.1459 16 14.6937 16 14.2222V1.77778C16 0.791111 15.2 0 14.2222 0ZM6.29333 11.1822L7.55556 12.4444L12 8L7.55556 3.55556L6.29333 4.80889L8.59556 7.11111H0V8.88889H8.59556L6.29333 11.1822Z"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SwitchLanguage = _resolveComponent("SwitchLanguage")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", { class: _ctx.dispalyActive }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "logo"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_svg_icon, { name: "logoTRS" })
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("ul", _hoisted_6, [
            _createVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                class: "link menu__link",
                "active-class": "active",
                to: "/admin",
                exact: ""
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('adaptiveTop.mainSystem')), 1 /* TEXT */)
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_8, [
              _createVNode(_component_router_link, {
                class: "link menu__link",
                "active-class": "active",
                to: "/",
                exact: ""
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('adminApp.toSite')), 1 /* TEXT */)
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_9, [
              _createVNode(_component_router_link, {
                class: "link menu__link",
                "active-class": "active",
                to: "/admin/user",
                exact: ""
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('adminApp.users')), 1 /* TEXT */)
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_10, [
              _createVNode(_component_router_link, {
                class: "link menu__link",
                "active-class": "active",
                to: "/admin/import",
                exact: ""
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('adaptiveTop.import')), 1 /* TEXT */)
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                class: "link menu__link",
                "active-class": "active",
                to: "/admin/articles",
                exact: ""
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('adaptiveTop.articles')), 1 /* TEXT */)
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_12, [
              _createVNode(_component_router_link, {
                class: "link menu__link",
                "active-class": "active",
                to: "/admin/FAQ",
                exact: ""
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('adaptiveTop.faq')), 1 /* TEXT */)
                ]),
                _: 1
              })
            ]),
            _hoisted_13,
            _createVNode("li", _hoisted_14, [
              _createVNode(_component_SwitchLanguage)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_router_link, {
              to: _ctx.data.url,
              class: "link user__link"
            }, {
              default: _withId(() => [
                _createVNode(_component_svg_icon, { name: "user" })
              ]),
              _: 1
            }, 8, ["to"]),
            (_ctx.authProfile)
              ? (_openBlock(), _createBlock("div", _hoisted_17, [
                  (_ctx.authProfile)
                    ? (_openBlock(), _createBlock("li", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(_component_router_link, {
                          to: "/profile",
                          class: "logout-profile__link",
                          exact: ""
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('adaptiveTop.account')), 1 /* TEXT */)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createBlock("li", _hoisted_20, [
                        _createVNode("div", _hoisted_21, [
                          _createVNode(_component_svg_icon, { name: "admin-with-cogwheels" })
                        ]),
                        _createVNode(_component_router_link, {
                          to: "/admin",
                          class: "logout-profile__link",
                          exact: ""
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('adaptiveTop.adminPanel')), 1 /* TEXT */)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.authProfile)
                    ? (_openBlock(), _createBlock("li", _hoisted_22, [
                        _hoisted_23,
                        _createVNode("button", {
                          class: "logout-profile__link",
                          onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.logout(...args)))
                        }, _toDisplayString(_ctx.$t('adaptiveTop.exit')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2)
  ]))
})